export default theme => ({
  mainContainer: {
    display: 'flex',
    flexDirection: 'column'
  },
  itemsContainer: {
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column'
  }
});
